module.exports = "<div class=\"outer-container\">\n\n  <div class=\"heading-row\">\n    <div class=\"heading\">\n      <h1 class=\"heading--no-margin\">Haven't I seen you before?</h1>\n    </div>\n  </div>\n\n  <div class=\"intro\">\n    <p>The email address <strong>{{ email }}</strong> is already associated with an account on Wattbike Hub.</p>\n    <p>Please sign in using email and password at the top right of this page.</p>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_769bc651/src/app/duplicateappleid/duplicateappleid.component.html
// module id = ../../../../../src/app/duplicateappleid/duplicateappleid.component.html
// module chunks = main